






























































































































import Vue, { PropOptions } from 'vue';
import { mapGetters } from 'vuex';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import moment from 'moment';

interface LocalState {
  coupon: CreateCouponRequest | UpdateCouponRequest | null;
}

interface Props {
  value: PropOptions;
  date: PropOptions;
}

export default Vue.extend({
  name: 'CouponForm',
  mixins: [DirtyMixin],
  props: {
    value: {
      type: Object as () => CreateCouponRequest | UpdateCouponRequest,
    },
    date: {
      type: Object as () => DatePicker,
    },
  } as Props,
  data(): LocalState {
    return {
      coupon: null,
    };
  },
  computed: {
    ...mapGetters({
      allActiveTeacherProducts: 'product/allActiveTeacherProducts',
      currency: 'studio/currency',
      paymentInfo: 'setting/paymentInfo',
    }),
    isDiscountTypeFixedAmount(): boolean {
      if (this.coupon) return this.coupon.discount_type === 'fixed_amount';
      return false;
    },
    isDurationTypeMonths(): boolean {
      if (this.coupon) return this.coupon.duration_type === 'months';
      return false;
    },
    hasPayPal() {
      return this.paymentInfo?.payment_gateway === 'paypal';
    },
  },
  mounted() {
    this.$store.dispatch('product/getTeacherProducts');
    this.$store.dispatch('setting/getPaymentInfo');
  },
  methods: {
    navigateBack(): void {
      this.$router.replace('/products/coupons');
    },
    generateRandomString(): void {
      if (this.coupon)
        this.coupon.code = Math.random().toString(36).substring(2);
    },
  },
  watch: {
    value: {
      handler(value: CreateCouponRequest | UpdateCouponRequest) {
        this.coupon = this.value;
        this.date.startDate = moment(this.coupon?.redeem_start).toDate();
        this.date.endDate = moment(this.coupon?.redeem_end).toDate();
      },
      immediate: true,
    },
    coupon: {
      handler: function (coupon, oldCoupon) {
        if (oldCoupon) {
          this.setDirty();
        }
      },
      deep: true,
    },
  },
});
